export default {
  "b2b.zadosti-historie-grid.action-filter": "Filter",
  "b2b.zadosti-historie-grid.filter.dateFrom.label": "Date from",
  "b2b.zadosti-historie-grid.filter.dateTo.label": "Date to",
  "b2b.zadosti-historie-grid.filter.requestStatus.label": "Request status",
  "b2b.zadosti-historie-grid.label": "Request history"
};
